import $ from 'jquery';

// Зависимые вопросы анкеты активности: длительность и плотность силовых
// не нужны тому, кто силовые не делает. Правило приходит с сервера
// в data-depends-*, шаблон о самих вопросах ничего не знает.
//
// Подписываться надо на ГЛОБАЛЬНЫЙ jQuery. Выпадающие списки оформлены
// плагином multiselect, и он сообщает о выборе через глобальный jQuery
// со страницы (3.5.1).
// У скриптов формы своя копия jQuery из сборки (3.6.0), и событие одной копии
// не доходит до обработчиков другой — зависимые вопросы не появлялись.
// Настоящее DOM-событие слушаем тоже: на случай, если список без плагина.
export function initActivityForm() {
    const $questions = $('.activity-question');
    if (!$questions.length) return;
    // Именно через document.defaultView, а не window.jQuery: webpack
    // (ProvidePlugin в webpack.config.js) подменяет выражение window.jQuery
    // на копию из сборки, и подписка снова ушла бы не туда.
    const $global = document.defaultView['jQuery'] || $;

    function refresh() {
        $('.activity-question[data-depends-on]').each(function () {
            const $question = $(this);
            const parent = $question.attr('data-depends-on');
            const notEquals = $question.attr('data-depends-not');
            const parentValue = $(`.activity-question[data-question="${parent}"] .activity-answer`).val();
            const visible = !!parentValue && parentValue !== notEquals;
            // Не toggle(): он выставляет display:block и ломает сетку,
            // потому что сам вопрос — элемент flex-контейнера.
            $question.css('display', visible ? '' : 'none');
            if (!visible) {
                const select = $question.find('.activity-answer').get(0);
                if (select && select.value) {
                    select.value = '';
                    // Подпись виджета обновляется только через плагин.
                    const $select = $global(select);
                    if ($select.multiselect) $select.multiselect('refresh');
                }
            }
        });
    }

    $global(document).on('change', '.activity-answer', refresh);
    document.addEventListener('change', (event) => {
        if (event.target && event.target.classList && event.target.classList.contains('activity-answer')) {
            refresh();
        }
    });
    refresh();
}
